<script setup>
import FormButton from '../../components/Atoms/FormButton.vue'
import IconBase from '../../components/icon/IconBase.vue'
import IconEye from '../../components/icon/IconEye.vue'
import IconEyeCrossed from '../../components/icon/IconEyeCrossed.vue'
import FloatingInput from '../../components/ui/FloatingInput.vue'

defineOptions({ name: 'PasswordVisibilityInput' })

defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  modelValue: { type: String, default: '' },
  visible: { type: Boolean, default: false },
  isError: { type: Boolean, default: false },
  helper: { type: String, default: '' },
  autocomplete: { type: String, default: 'off' }
})

const emit = defineEmits(['update:modelValue', 'toggle-visible'])
</script>

<template>
  <div class="relative password-visibility-input">
    <FloatingInput
      :id="id"
      :label="label"
      :type="visible ? 'text' : 'password'"
      surface="2"
      :model-value="modelValue"
      :has-error="isError"
      :helper="helper"
      :autocomplete="autocomplete"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <FormButton
      is-icon
      type="link"
      class="absolute right-2 top-3 z-10"
      @click="emit('toggle-visible')"
    >
      <IconBase>
        <IconEye v-if="!visible" />
        <IconEyeCrossed v-else />
      </IconBase>
    </FormButton>
  </div>
</template>

<style scoped>
.password-visibility-input :deep(.ff__input) {
  padding-right: 2.75rem;
}
</style>
